import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { getLocaleData } from '@/selectors/localeSelectors';
import { supportedCountries } from '@/constants/supportedLocales';
import { useRouteParams } from '@/context/routeParamsContext';
import NotFound from './NotFound';
import { isNewUrl } from '../helpers/utils';

const LoungeFinderErrorBoundary = ({ children }) => {
  const [show404Page, setShow404Page] = useState(false);
  const { product, locale: routeLocale } = useRouteParams();
  const { locale } = useSelector(getLocaleData);

  useEffect(() => {
    let urlLocale = locale;
    if (isNewUrl()) {
      urlLocale = routeLocale;
    }
    const supportedCountry = supportedCountries.find(
      (country) => country.locale === urlLocale.toLocaleLowerCase()
    );
    const validPath = supportedCountry?.products.includes(product);
    setShow404Page(!validPath);
  }, [locale, product, routeLocale]);

  if (show404Page) {
    return <NotFound />;
  }

  return children;
};

LoungeFinderErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};

export default LoungeFinderErrorBoundary;
